import * as React from "react";

import "./page-size.scss";

import {cs}    from "@Common/react/chain-services";
import {Types} from "@Common/types";

import {SelectRaw} from "../../../../../select-raw";

export const PAGE_SIZE_ALL = Infinity;

export const PageSize = ({state, extraSizes=undefined, xdQaNamePrefix=undefined, pageSizeMessage="Results per page", sizes=[10, 20, 30]}:{
    extraSizes      ?: Array<number>,
    pageSizeMessage ?: string,
    sizes           ?: Array<number>,
    state            : Types.Common.React.UseState.UseStateNext<number>,
    xdQaNamePrefix  ?: string,
}) => cs(
    () => (
        <div className="page-size page-size-4oa">
            {SelectRaw({
                list: [
                    ...sizes,
                    ...extraSizes??[],
                ],
                valueToLabel: (size) => size === PAGE_SIZE_ALL ? "All" : size,
                isSelected: (v) => state.value === v,
                onChange: state.onChange,
                xdQaName: (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Results Per Page",
            })}
            <div className="text" xd-qa-type="label" xd-qa-name={(xdQaNamePrefix ? xdQaNamePrefix+" " : "")+pageSizeMessage}>
                {pageSizeMessage}
            </div>
        </div>
    ),
);

